import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from '@app/auth/auth-guard.service';
import {ReviewComponent} from '@app/review/review/review.component';

const routes: Routes = [
    { path: 'r/', component: ReviewComponent, canActivate: [AuthGuardService] },
    { path: 'r/:reviewId', component: ReviewComponent, canActivate: [AuthGuardService] },
    { path: 'r/:reviewId/:assetId', component: ReviewComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ReviewRoutingModule {}
